var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{ref:"viewerModal",attrs:{"values":{ id: 'viewer_modal', size: 'lg' },"noCloseOnBackdrop":false,"onClose":{},"hideFooter":true},on:{"onShown":_vm.whenModalVisible}},[_c('template',{slot:"body"},[_c('ImageViewer',{ref:"viewer",attrs:{"images":_vm.images,"fileIndex":_vm.index,"thumbs":_vm.thumbs}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }